<script>
import { Line, mixins } from "vue-chartjs";
import chartMixins from "./chartMixin";

const { reactiveProp } = mixins;

export default {
	extends: Line,
	mixins: [chartMixins, reactiveProp],
	props: {},
	computed: {
		options() {
			return {
				legend: {
					display: false
				},
				responsive: true,
				maintainAspectRatio: false,
				scales: {
					yAxes: [
						{
							display: true,
							ticks: {
								beginAtZero: true // minimum value will be 0.
							}
						}
					],
					xAxes: [
						{
							gridLines: {
								drawOnChartArea: false
							},
							display: true,
							ticks: {
								fontSize: 13
							}
						}
					]
				},
				tooltips: {
					enabled: this.showTooltip
				}
			};
		}
	},
	mounted() {
		this.renderChart(this.chartData, this.options);
	}
};
</script>
